
import Vue from 'vue'
import { Prop } from 'vue-property-decorator'
import Component from 'vue-class-component'
import Role from '../models/role'
import RoleTemplate from '../templates/roleTemplate'
import GreenButton from '../components/Atomic/GreenButton.vue'
import RedButton from '../components/Atomic/RedButton.vue'
import CardTitle from '../components/Atomic/CardTitle.vue'
import ProgressLinear from '../components/Atomic/ProgressLinear.vue'

@Component({
  components: {
    CardTitle,
    GreenButton,
    RedButton,
    ProgressLinear,
  },
})
export default class DeleteRole extends Vue {
  public isPending: boolean = false
  public role: RoleTemplate = new RoleTemplate(new Role(1, '', '', [], -2))
  public dialog: boolean = false

  @Prop(Function) public readonly delete!: (role: RoleTemplate) => void

  public hide() {
    this.dialog = false
  }
  public show(roleTemplate: RoleTemplate) {
    this.dialog = true
    this.role = roleTemplate
  }
  private async no() {
    this.hide()
  }

  private async yes() {
    this.isPending = true
    await this.delete(this.role)
    this.isPending = false
    this.hide()
  }
}
